var map = {
	"./apple-m.jpg": "KwLr",
	"./bellini-bliss-m.jpg": "pyMR",
	"./blackberry-m.jpg": "iWn4",
	"./blueberry-pomegranate-m.jpg": "/YYb",
	"./cherry-m.jpg": "+T0M",
	"./citrus-cherry-m.jpg": "2ylf",
	"./coconut-pineapple-m.jpg": "TAGP",
	"./cranberry-m.jpg": "eXTr",
	"./grapefruit-m.jpg": "hNyz",
	"./lemon-m.jpg": "MwnU",
	"./lime-m.jpg": "aJI9",
	"./mango-m.jpg": "Bc2q",
	"./mango-passionfruit-m.jpg": "Fdmo",
	"./orange-cream-m.jpg": "w7JI",
	"./orange-m.jpg": "VxFN",
	"./passionfruit-m.jpg": "8I3e",
	"./peach-m.jpg": "8uxE",
	"./pineapple-m.jpg": "DaG7",
	"./raspberry-m.jpg": "CGCn",
	"./strawberry-m.jpg": "FZJu",
	"./strawberry-sunset-m.jpg": "Cnwy",
	"./triple-berry-m.jpg": "skPN",
	"./watermelon-m.jpg": "u7xA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jRIy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds ^\.\/.*\-m\.jpg$
// module id = jRIy
// module chunks = 0